// vendor/list-product
import api, { authClient } from '.';
import Cookie from 'universal-cookie';
import { toast } from 'react-toastify';

const cookies = new Cookie();
const config = {
  headers: {
    authorization: `Bearer ${cookies.get('authToken')}`,
  },
};

// Fetch All products
export const getAllVendorProducts = async token => {
  const configProd = {
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`/vendor/list-product`, configProd);
      resolve(res);
      // console.log(res)
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

// Fetch All products
export const addContest = async data => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.post(`/vendor/add-contest`, data, config);
      resolve(res);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};

//fetch all contest 
export const viewContest = async data => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await authClient.get(`vendor/get-contest`, data, config);
      resolve(res.json());
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookies.remove('authToken', { path: '/' });
          cookies.remove('user', { path: '/' });
          cookies.remove('userId', { path: '/' });
          toast.error('Your session has expired. Please login again.');
          window.location.href = '/auth/sign-in';
        } else if (status === 400) {
          toast.error(data.message || 'Bad Request: Invalid request data.');
        } else if (status === 403) {
          toast.error('Forbidden: You do not have permission to access this resource.');
        } else if (status === 404) {
          toast.error('Not Found: The requested product could not be found.');
        } else if (status === 500) {
          toast.error('Server Error: Please try again later.');
        } else {
          toast.error(data.message || 'An error occurred while fetching the product details.');
        }
      } else if (error.request) {
        toast.error('Network Error: Please check your internet connection and try again.');
      } else {
        toast.error('Error: ' + error.message);
      }
      reject(error);
    }
  });
};
